(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
  const closeMenu = menu => {
    if (!menu?.open) return;
    menu.open = false;
    menu.querySelector('summary')?.focus({ preventScroll: true });
  };
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.('[data-paw-menu]') || !menu.open) return;
    menu.querySelector('.paw-menu__drawer button')?.focus({ preventScroll: true });
  }, true);
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-paw-menu-close]');
    if (close) closeMenu(close.closest('[data-paw-menu]'));
    const link = event.target.closest('.paw-menu__drawer a');
    if (link) closeMenu(link.closest('[data-paw-menu]'));
  });
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('[data-paw-menu][open]');
    if (!menu) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu(menu);
      return;
    }
    if (event.key !== 'Tab') return;
    const items = [...menu.querySelector('.paw-menu__drawer').querySelectorAll(focusableSelector)].filter(item => item.getClientRects().length);
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-paw-language]')) event.target.form?.requestSubmit();
  });
})();

(() => {
  let interval;
  function deadline(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,3})?(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const [, year, month, day, hours, minutes, seconds, zone] = match;
    const maxDay = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
    if (Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > maxDay || Number(hours) > 23 || Number(minutes) > 59 || Number(seconds) > 59) return NaN;
    if (zone !== 'Z' && (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4, 6)) > 59)) return NaN;
    return Date.parse(value);
  }
  function renderCountdowns() {
    let active = 0;
    document.querySelectorAll('[data-countdown]').forEach(timer => {
      const end = deadline(timer.dataset.countdownEnd);
      const duration = Number(timer.dataset.countdownDuration) * 1000;
      const repeat = timer.dataset.countdownRepeat === 'true' && Number.isFinite(duration) && duration > 0;
      const now = Date.now();
      let milliseconds = end - now;
      if (repeat && milliseconds <= 0) milliseconds = duration - ((now - end) % duration);
      const remaining = Math.max(0, Math.ceil(milliseconds / 1000));
      timer.hidden = !Number.isFinite(end) || remaining <= 0;
      if (timer.hidden) return;
      active++;
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      Object.entries(values).forEach(([unit, value]) => {
        const node = timer.querySelector(`[data-countdown-value="${unit}"]`);
        const formatted = String(value).padStart(2, '0');
        if (node && node.textContent !== formatted) node.textContent = formatted;
      });
    });
    return active;
  }
  function startCountdowns() {
    clearInterval(interval);
    if (renderCountdowns() && !document.hidden) interval = setInterval(() => { if (!renderCountdowns()) clearInterval(interval); }, 1000);
  }
  startCountdowns();
  document.addEventListener('shopify:section:load', startCountdowns);
  document.addEventListener('visibilitychange', startCountdowns);
  window.addEventListener('pageshow', startCountdowns);
})();
